/** Dictation helpers shared by the chat input and the compose window. */

/** File name of the recording, with the extension of the type the recorder really used
 * (Safari records audio/mp4 even when asked for nothing). */
export function recordingFileName(mimeType: string): string {
  const type = (mimeType || '').split(';')[0].trim().toLowerCase()
  if (type === 'audio/mp4' || type === 'audio/x-m4a' || type === 'audio/aac') return 'recording.m4a'
  if (type === 'audio/ogg') return 'recording.ogg'
  if (type === 'audio/wav' || type === 'audio/x-wav') return 'recording.wav'
  return 'recording.webm'
}

/** What to tell the user when the transcription request failed: the server's own detail
 * (an Italian constant of the backend), else `fallback`. */
export async function transcriptionErrorText(resp: Response | null, fallback: string): Promise<string> {
  if (resp) {
    try {
      const data = await resp.json()
      if (typeof data?.detail === 'string' && data.detail) return data.detail
    } catch {
      // not JSON (proxy error page): the fixed text
    }
  }
  return fallback
}
